import Questionnaire from '../../component/subscriptionManage';

const SubscriptionQuestionnairePage = () => {
  return (
    <div>
      <Questionnaire />
    </div>
  );
};

export default SubscriptionQuestionnairePage;
